import { render, staticRenderFns } from "./MyDebits.vue?vue&type=template&id=287fffcc&scoped=true"
import script from "./MyDebits.vue?vue&type=script&lang=js"
export * from "./MyDebits.vue?vue&type=script&lang=js"
import style0 from "./MyDebits.vue?vue&type=style&index=0&id=287fffcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287fffcc",
  null
  
)

export default component.exports